import { render, staticRenderFns } from "./ColorCheckboxList.vue?vue&type=template&id=1c923593&scoped=true"
import script from "./ColorCheckboxList.vue?vue&type=script&lang=js"
export * from "./ColorCheckboxList.vue?vue&type=script&lang=js"
import style0 from "./ColorCheckboxList.vue?vue&type=style&index=0&id=1c923593&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c923593",
  null
  
)

export default component.exports